module.exports = __webpack_public_path__ + "files/SPIADI - Guide Pratique Lily 2.de737b6ca7e2648951ae1dea0bd715aa.pdf";